export const deviceLicenses = {
  advancedFlow: "advanced-flow",
  dashboards: "dashboards",
  moods: "moods",
}